import { Component, Signal, inject, ChangeDetectionStrategy } from '@angular/core'
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core'
import { StateService } from '../../../services/state.service'
import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonItem,
  IonList,
  IonRadio,
  IonRadioGroup,
  IonTitle,
  IonToolbar,
} from '@ionic/angular'
import { RouterLink } from '@angular/router'
import { FirebaseAnalyticsService } from '../../../services/firebase-analytics.service'
import { AnalyticsEvents } from '../../../models/analytics-events'

@Component({
  selector: 'app-settings-target-group',
  templateUrl: './settings-target-group.component.html',
  styles: `
    ion-radio::part(label) {
      display: block;
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    IonHeader,
    IonButtons,
    IonToolbar,
    IonBackButton,
    IonTitle,
    IonContent,
    IonList,
    IonRadioGroup,
    IonItem,
    IonRadio,
    RouterLink,
    TranslateDirective,
    TranslatePipe,
  ],
})
export class SettingsTargetGroupComponent {
  private stateService = inject(StateService)
  private firebaseAnalyticsService = inject(FirebaseAnalyticsService)

  readonly targetGroup: Signal<'pre-existing' | 'gestational' | undefined>
  constructor() {
    this.targetGroup = this.stateService.targetGroup
  }
  setTargetGroup(event: CustomEvent) {
    const type = event.detail.value
    this.stateService.setTargetGroup(type)
    const eventName =
      type === 'gestational' ? AnalyticsEvents.TARGET_GROUP_GESTATIONAL : AnalyticsEvents.TARGET_GROUP_PRE_EXISTING
    this.firebaseAnalyticsService.trackEvent(eventName, {})
  }
}
